import { useContext, useState } from "react";
import { YearContext, AuthContext } from "../../context/context";
import GoalCard from "./CardGoal";
import NavSidebarEdit from "../Sidebar/NavSidebarEdit";
import { capitalizeString } from "../../utils/stringUtils";
import PropTypes from "prop-types";

const GoalCategoriesColumns = ({ handleDeleteClick }) => {
  const { selectedYear } = useContext(YearContext);
  const { userData } = useContext(AuthContext);

  const [sidebarEditToggled, setSidebarEditToggled] = useState(false);
  const [selectedGoalId, setSelectedGoalId] = useState(null);

  const goals = Array.isArray(userData?.goals) ? userData.goals : [];
  const selectedGoal = goals.find((goal) => goal.id === selectedGoalId);
  const filteredData = selectedYear
    ? goals.filter((goal) => goal.year === selectedYear)
    : goals;

  const groupedGoals = filteredData.reduce((acc, goal) => {
    const category = capitalizeString(goal.category);
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(goal);
    return acc;
  }, {});

  const handleEditClick = (goal) => {
    setSelectedGoalId(goal.id);
    setSidebarEditToggled(true);
  };

  const handleDelete = (goalId) => {
    handleDeleteClick(goalId);
  };

  return (
    <>
      {filteredData.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {Object.keys(groupedGoals).map((category) => (
            <div className="flex flex-col gap-2" key={category}>
              <h2 className="text-xl font-semibold">{category}</h2>
              {groupedGoals[category].map((goal) => {
                const goalMilestones = userData.milestones.filter(
                  (milestone) => milestone.goal_id === goal.id
                );

                return (
                  <GoalCard
                    key={goal.id}
                    goalMilestones={goalMilestones}
                    title={goal.title}
                    goal={goal}
                    onEdit={handleEditClick}
                    onDelete={handleDelete}
                  />
                );
              })}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No goals for this year.</p>
      )}

      {sidebarEditToggled && selectedGoal && (
        <NavSidebarEdit
          setSidebarEditToggled={setSidebarEditToggled}
          selectedGoal={selectedGoal}
        />
      )}
    </>
  );
};

GoalCategoriesColumns.propTypes = {
  handleDeleteClick: PropTypes.func.isRequired,
};

export default GoalCategoriesColumns;
